module.exports = __webpack_public_path__ + "img/VP-Lite_Overview-Rear_2.ba5578a1.jpg";